export default function Terms() {
  const sections = [
    ["Acceptance of Terms", "By downloading or using MiiQ FitFinder, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the app."],
    ["Use of the App", "MiiQ FitFinder is intended for personal, non-commercial use. You agree not to misuse the app, attempt to gain unauthorized access, or use the app for any unlawful purpose."],
    ["Subscriptions and Payments", "Some features require a paid subscription. Subscriptions are billed through Apple App Store or Google Play. You can cancel anytime through your store account settings."],
    ["Refunds", "Refund requests are handled by Apple or Google according to their respective refund policies. Contact support@miiqfitfinder.com for assistance."],
    ["Intellectual Property", "All content, features, and functionality of MiiQ FitFinder are owned by Taradome Entertainment Group LLC and are protected by copyright and other intellectual property laws."],
    ["Disclaimer of Warranties", "MiiQ FitFinder is provided as-is without warranties of any kind. Career assessments and recommendations are for informational purposes only and do not constitute professional career advice."],
    ["Limitation of Liability", "Taradome Entertainment Group LLC shall not be liable for any indirect, incidental, or consequential damages arising from your use of the app."],
    ["Changes to Terms", "We reserve the right to modify these terms at any time. Continued use of the app after changes constitutes acceptance of the new terms."],
    ["Contact Us", "For questions about these Terms, contact us at support@miiqfitfinder.com."],
  ];
  return (
    <div style={s.page}>
      <div style={s.blob1}/><div style={s.blob2}/>
      <div style={s.container}>
        <div style={s.logoRow}>
          <img src="/logo.png" alt="MiiQ FitFinder" style={{height:64,borderRadius:12}}/>
        </div>
        <div style={s.hero}>
          <div style={s.badge}>Legal</div>
          <h1 style={s.h1}>Terms of <span style={{color:"#D4AF37"}}>Service</span></h1>
          <p style={s.sub}>Last updated: May 2026</p>
        </div>
        <div style={s.card}>
          {sections.map(([title, text], i) => (
            <div key={i} style={{...s.section, borderBottom: i < (sections.length - 1) ? "1px solid rgba(212,175,55,0.1)" : "none"}}>
              <div style={s.sectionNum}>{String(i+1).padStart(2,"0")}</div>
              <div style={{flex:1}}>
                <h2 style={s.h2}>{title}</h2>
                <p style={s.text}>{text}</p>
              </div>
            </div>
          ))}
        </div>
        <div style={s.footer}>
          <a href="/support" style={s.backLink}>Back to Support</a>
          <span style={s.footerText}>2026 Taradome Entertainment Group LLC</span>
        </div>
      </div>
    </div>
  );
}
const s = {
  page:{background:"#2E1A47",minHeight:"100vh",color:"#F9F7F2",fontFamily:"Georgia,serif",overflowX:"hidden",position:"relative"},
  blob1:{position:"fixed",inset:0,background:"radial-gradient(ellipse 80% 50% at 20% 10%,rgba(212,175,55,0.08) 0%,transparent 60%)",pointerEvents:"none",zIndex:0},
  blob2:{position:"fixed",inset:0,background:"radial-gradient(ellipse 60% 80% at 80% 90%,rgba(75,54,99,0.4) 0%,transparent 60%)",pointerEvents:"none",zIndex:0},
  container:{maxWidth:760,margin:"0 auto",padding:"40px 24px 60px",position:"relative",zIndex:1},
  logoRow:{display:"flex",alignItems:"center",marginBottom:48},
  hero:{marginBottom:40},
  badge:{display:"inline-block",background:"rgba(212,175,55,0.1)",border:"1px solid rgba(212,175,55,0.3)",borderRadius:20,padding:"4px 14px",fontSize:11,letterSpacing:"0.1em",textTransform:"uppercase",color:"#D4AF37",marginBottom:16},
  h1:{fontSize:42,fontWeight:700,lineHeight:1.1,color:"#F9F7F2",marginBottom:8},
  sub:{fontSize:14,color:"#9A8C9D"},
  card:{background:"rgba(61,38,90,0.4)",border:"1px solid rgba(212,175,55,0.15)",borderRadius:20,padding:"8px 32px",marginBottom:40},
  section:{display:"flex",gap:24,padding:"28px 0",alignItems:"flex-start"},
  sectionNum:{fontSize:11,fontWeight:700,color:"rgba(212,175,55,0.4)",letterSpacing:"0.1em",minWidth:28,paddingTop:4},
  h2:{fontSize:16,fontWeight:600,color:"#F9F7F2",marginBottom:8,fontFamily:"Georgia,serif"},
  text:{fontSize:14,color:"#9A8C9D",lineHeight:1.8,margin:0},
  footer:{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12},
  backLink:{color:"#D4AF37",textDecoration:"none",fontSize:14},
  footerText:{fontSize:12,color:"rgba(154,140,157,0.5)"},
};
